import { useDispatch, useSelector } from "react-redux";
import AllInOnePage from "../questionarea/AllInOnePage";
// import AllInOnePage from "../questionarea/AllInOnePage";
import MasterGroupHeaderAndQuestions from "../questionarea/MasterGroupHeaderAndQuestions";
import {
  LOCATION,
  MASTERGROUP,
  OPERATION,
  initializeBuilding,
} from "../store/businesslogic/hardwiredlogic";

import _ from "lodash";
import {
  getCurrentNode,
  getFormAllInOnePage,
  getGroupsOrder,
  getGroupsOrderFromLocationState,
  getBuildings,
  addBuildingToLocationState,
  getBuilding,
  getFormState,
  setShowFirstAutoAddedBuilding,
  getShowFirstAutoAddedBuildingState,
  resetState,
} from "../store/qf";
import LocationGroupHeaderAndQuestions from "../questionarea/LocationGroupHeaderAndQuestions";
import BuildingGroupHeaderAndQuestions from "../questionarea/BuildingGroupHeaderAndQuestions";
import { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import { first } from "underscore";
import { unmountComponentAtNode } from "react-dom";
import { getBrokerInformation } from "../store/broker";
import translations from "../utils/translations";

const QuestionArea = () => {
  const currentnode = useSelector(getCurrentNode);
  const dispatch = useDispatch();
  useEffect(() => {
    // This function will be called when the component mounts
    // Return a function that will be called when the component unmounts
    return () => {
      dispatch(resetState());
    };
  }, []); // The empty array means this effect runs once on mount and the return runs on unmount

  if (
    currentnode?.formtype === MASTERGROUP ||
    currentnode?.formtype === OPERATION
  )
    return (
      <MasterGroupQuestionArea
        currentnode={currentnode}
      ></MasterGroupQuestionArea>
    );
  if (currentnode?.formtype === LOCATION)
    return (
      <LocationQuestionArea currentnode={currentnode}></LocationQuestionArea>
    );

  // if (currentnode.formtype === OPERATION)
  //   return (
  //     <OperationQuestionArea currentnode={currentnode}></OperationQuestionArea>
  //   );

  return <div>There is no form formtype {currentnode?.formtype}</div>;
};

const MasterGroupQuestionArea = ({ currentnode }) => {
  const allinonepage = useSelector(getFormAllInOnePage(currentnode.formid));

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <AllInOnePageMasterGroup
        currentnode={currentnode}
        allinonepage={allinonepage}
      ></AllInOnePageMasterGroup>
    </div>
  );
};

const AllInOnePageMasterGroup = ({ currentnode, allinonepage }) => {
  return (
    <AllInOnePage
      Scrollable={MasterGroupScrollable}
      currentnode={currentnode}
      allinonepage={allinonepage}
    ></AllInOnePage>
  );
};

const findFirstGroupIdAndLastGroupId = ({ groupsOrder }) => {
  let firstGroupId = null;
  let lastGroupId = null;
  if (!_.isEmpty(groupsOrder)) {
    firstGroupId = groupsOrder[0];
    lastGroupId = groupsOrder[groupsOrder.length - 1];
  }

  return { firstGroupId, lastGroupId };
};

const MasterGroupScrollable = ({
  currentnode,
  allinonepage,
  mainDivRef,
  handleShowScroll,
}) => {
  const formid = currentnode.formid;
  const currentgroupid = currentnode.groupid;

  let groupsOrder = useSelector(getGroupsOrder(formid));

  if (!allinonepage) groupsOrder = [currentgroupid];

  const { firstGroupId, lastGroupId } = findFirstGroupIdAndLastGroupId({
    groupsOrder,
  });

  return (
    <div style={{ height: "100%" }}>
      {groupsOrder.map((groupid) => (
        <MasterGroupHeaderAndQuestions
          key={groupid}
          groupid={groupid}
          formid={formid}
          mainDivRef={mainDivRef}
          handleShowScroll={handleShowScroll}
          firstGroupId={firstGroupId}
          lastGroupId={lastGroupId}
          allinonepage={allinonepage}
        ></MasterGroupHeaderAndQuestions>
        // <div key={groupid}>
        //   <div
        //     style={{ height: h, backgroundColor: "green" }}
        //     onClick={() => {
        //       setH("200vh");
        //     }}
        //     onDoubleClick={() => {
        //       setH("20vh");
        //     }}
        //   >
        //     a
        //   </div>
        // </div>
        // <div style={{ height: "120vh", backgroundColor: "green" }}>a</div>
        // <EachGroup
        //   key={`allinone_${formid}_${groupid}`}
        //   formid={formid}
        //   groupid={groupid}
        // ></EachGroup>
      ))}
    </div>
  );
};

const LocationQuestionArea = ({ currentnode }) => {
  return (
    <AllInOnePage
      Scrollable={LocationGroupScrollable}
      currentnode={currentnode}
      allinonepage={true}
    ></AllInOnePage>
  );
};

const LocationGroupScrollable = ({
  currentnode,
  mainDivRef,
  handleShowScroll,
  allinonepage,
}) => {
  const dispatch = useDispatch();
  const formid = currentnode.formid;
  const locationid = currentnode.locationid;
  const buildingid = currentnode.buildingid;
  const formState = useSelector(getFormState);
  const [showAddBuildingBtn, setshowAddBuildingBtn] = useState(false);
  const [buildingGroupOrder, setBuildingGroupOrder] = useState([]);
  const groupsOrder = useSelector(
    getGroupsOrderFromLocationState({ locationid, formid })
  );
  const showAutoAddedBuilding = useSelector(getShowFirstAutoAddedBuildingState);
  // const buildingInfo = useSelector(getBuildings({ formid, locationid }));
  const buildingInfo = useSelector(
    getBuilding({ formid, locationid, buildingid: buildingid })
  );
  let lastBuildingIndex =
    formState[formid]?.locationstate[locationid]?.buildings?.length - 1;
  const { firstGroupId, lastGroupId } = findFirstGroupIdAndLastGroupId({
    groupsOrder,
  });
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  // const {buildingFirstGroupId,bulidingLastGroupId} =findFirstGroupIdAndLastGroupId({
  //   buildingInfo.grouporder,
  // });

  const [buildingLocations, setBuildingLocations] = useState([
    { id: 1, groups: groupsOrder },
  ]);

  useEffect(() => {
    dispatch(setShowFirstAutoAddedBuilding(true));
    if (
      buildingInfo?.groupsorder?.length > 1 &&
      formState[formid].locationstate[locationid].buildings[lastBuildingIndex]
        .groupsorder.length > 1
    ) {
      setshowAddBuildingBtn(true);
    } else {
      setshowAddBuildingBtn(false);
    }
  }, [buildingInfo]);

  // Adding a new building handler
  const addNewBuilding = ({ focusDisabled } = {}) => {
    const groupsOrderCopy = [...groupsOrder];
    let newBuildingIndex = _.cloneDeep(
      formState[formid].locationstate[locationid].buildings.length
    );

    if (
      formState[formid].locationstate[locationid].buildings[0].groupsorder
        .length === 0
    ) {
      newBuildingIndex = 0;
    }
    // addBuildingToLocationState({ formid, locationid, buildingIndex: 0 });
    //The building is automatically created once the user answers a specific location question.
    //I need to hide it until the user manually adds in the building themselves
    if (!showAutoAddedBuilding) {
      dispatch(setShowFirstAutoAddedBuilding(true));
    } else {
      dispatch(
        addBuildingToLocationState({
          formid,
          locationid,
          buildingIndex: newBuildingIndex,
          focusDisabled,
        })
      );
    }
  };

  useEffect(() => {
    if (buildingInfo) {
      const { firstGroupId, lastGroupId } = findFirstGroupIdAndLastGroupId({
        groupsorder: buildingInfo.groupsorder,
      });
      setBuildingGroupOrder({ firstGroupId, lastGroupId });
    }
  }, [currentnode]);

  useEffect(() => {
    let tempBuildingInfo = _.cloneDeep(buildingInfo);
    if (buildingInfo?.groupsorder && buildingInfo?.groupsorder.length > 0) {
      const lastElement = tempBuildingInfo.groupsorder.pop();
      const newGroupsOrder = [lastElement, ...tempBuildingInfo.groupsorder];
      setBuildingGroupOrder(newGroupsOrder);
    }
  }, [buildingInfo]);

  useEffect(() => {
    if (
      groupsOrder.includes("e_100_50") &&
      formState[formid].locationstate[locationid].buildings[0].groupsorder
        .length == 0
    ) {
      addNewBuilding({ focusDisabled: true });
    }
  }, [groupsOrder]);

  return (
    <div style={{ height: "100%" }}>
      <div style={{ marginBottom: "10px" }}>
        {(isNaN(Number(buildingid)) || buildingid === "") &&
          groupsOrder.length > 0 &&
          groupsOrder.map((groupid) => {
            if (groupid != "e_100_50") {
              return (
                <LocationGroupHeaderAndQuestions
                  key={`groupid_location_${groupid}_${locationid}`}
                  groupid={groupid}
                  formid={formid}
                  locationid={locationid}
                  mainDivRef={mainDivRef}
                  handleShowScroll={handleShowScroll}
                  firstGroupId={firstGroupId}
                  lastGroupId={lastGroupId}
                  allinonepage={allinonepage}
                  isBuilding={false}
                ></LocationGroupHeaderAndQuestions>
              );
            } else return <></>;
          })}
      </div>
      <div>
        {buildingInfo &&
          buildingInfo.groupsorder.map((groupId) => {
            return (
              <div>
                <BuildingGroupHeaderAndQuestions
                  key={`groupid_location_${groupId}_${locationid}_${buildingid}`}
                  groupid={groupId}
                  formid={formid}
                  locationid={locationid}
                  mainDivRef={mainDivRef}
                  handleShowScroll={handleShowScroll}
                  firstGroupId={"e_100_50"}
                  lastGroupId={"e_320"}
                  allinonepage={allinonepage}
                  isBuilding={true}
                  buildingIndex={buildingid}
                ></BuildingGroupHeaderAndQuestions>
              </div>
            );
          })}
        {/* 
        {buildingInfo.map((building, index) => {
          return building.groupsorder.map((groupId) => {
         
            return (
              <div>
                <BuildingGroupHeaderAndQuestions
                  key={`groupid_location_${groupId}_${locationid}_${index}`}
                  groupid={groupId}
                  formid={formid}
                  locationid={locationid}
                  mainDivRef={mainDivRef}
                  handleShowScroll={handleShowScroll}
                  firstGroupId={"e_100_4"}
                  lastGroupId={"e_320"}
                  allinonepage={allinonepage}
                  isBuilding={true}
                  buildingIndex={index}
                ></BuildingGroupHeaderAndQuestions>
              </div>
            );
          });
        })} */}
        {_.includes(groupsOrder, "e_100_50") && showAddBuildingBtn && false && (
          <Button
            style={{
              backgroundColor: "rgb(234, 143, 96)",
              color: "white",
              padding: "10px",
              margin: "10px",
            }}
            onClick={() => addNewBuilding()}
          >
            {" "}
            {translations[languagepreference].addBuilding}
          </Button>
        )}
      </div>
    </div>
  );
};

export default QuestionArea;
